import styled from '@emotion/styled'

export const OOBESignUpForm = styled.form`
  display: flex;
  flex-direction: column;
  height: 534px;
  @media all and (max-height: 754px) and (max-width: 661px) {
    height: 420px;
  }
`

export const FormContainer = styled.div`
  flex: 1;
  > * {
    margin-top: 20px;
  }
  > div:nth-of-type(1) {
    margin-top: 0px;
  }
`

// Workaround for the checkbox label don't breaking the words
export const CheckBoxWrapper = styled.p`
  > span {
    word-break: normal !important;
  }
`

export const GreetingText = styled.p`
  margin: 0;
`

export const DescriptionText = styled.p`
  margin: 20px 0;
`

export const FormFooter = styled.div<{ isRTL?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  > button {
    margin-top: 20px;
  }
  ${(props) =>
    props.isRTL &&
    `
    button {
      margin-top: 20px;
    }
  `}
  > div:nth-of-type(1) {
    margin-top: 10px;
  }
`
